import styled from "styled-components";


export const TextValidation = styled.span`
    font-size: 9px;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    color:red;
    padding:0px;
    margin:0px;
`;